import Icon from '../components/Icon.vue'

Icon.register({
  syringe: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M201.5 174.8L257.2 230.6C260.3 233.7 260.3 238.8 257.2 241.9L245.9 253.2C242.8 256.3 237.7 256.3 234.6 253.2L178.9 197.4 133.6 242.7 189.4 298.5C192.5 301.6 192.5 306.7 189.4 309.8L178.1 321.1C175 324.2 169.9 324.2 166.8 321.1L111 265.2 84.6 291.6C67.3 308.9 59 332.7 61.6 357L68.7 420.6 2.3 487C-0.8 490.1-0.8 495.2 2.3 498.3L13.6 509.6C16.7 512.7 21.8 512.7 24.9 509.6L91.2 443.3 154.8 450.4C178.7 453 202.7 445 220.2 427.4L402.1 245.5 266.4 109.8 201.5 174.8zM509.7 81.5L430.5 2.3C427.4-0.8 422.3-0.8 419.2 2.3L407.9 13.6C404.8 16.7 404.8 21.8 407.9 24.9L436.2 53.2 390.9 98.5 334.3 41.9 317.3 24.9C314.2 21.8 309.1 21.8 306 24.9L272.1 58.8C269 61.9 269 67 272.1 70.1L289.1 87.1 424.8 223 441.8 240C444.9 243.1 450 243.1 453.1 240L487 206C490.1 202.9 490.1 197.8 487 194.7L413.5 121.2 458.8 75.9 487.1 104.2C490.2 107.3 495.3 107.3 498.4 104.2L509.7 92.9C512.8 89.7 512.8 84.7 509.7 81.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/syringe.js
// module id = VPcC
// module chunks = 144